exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.porc_funnel {\n  font-size: 10px !important;\n}\n.label__value {\n  font-size: 12px !important;\n  margin-bottom: 0px !important;\n}\n.svg-funnel-js.svg-funnel-js--vertical .svg-funnel-js__label {\n  padding-top: 5px !important;\n}\n", ""]);

// exports
